import { Component, OnInit, SimpleChanges, Input } from '@angular/core';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Question } from 'app/shared/models/question';
import { ListQuestion } from 'app/shared/models/list-question';
import { QuestionSetLabel } from 'app/shared/models/question-set-label';
import { UniqueIdService } from 'app/shared/services/unique-id.service';

@Component({
  selector: 'dac-question-labels-edit',
  templateUrl: './question-labels-edit.component.html',
  styleUrls: ['./question-labels-edit.component.scss']
})
export class QuestionLabelsEditComponent implements OnInit, OnChanges {
  
  @Input() question:ListQuestion;

  public labels:QuestionSetLabel[];
  public newLabel:QuestionSetLabel;

  constructor(private uuid:UniqueIdService) { 
    this.labels = [];
    this.createNewLabel();
  }

  ngOnInit() {
    this.updateLabels();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateLabels();
  }

  private createNewLabel() {
    this.newLabel = new QuestionSetLabel();
    this.newLabel.id = this.uuid.generate();
  }

  public addLabel() {
    this.question.addLabel(this.newLabel);
    this.updateLabels();
    this.createNewLabel();
  }

  public shiftUpLabel(label:QuestionSetLabel) {
    this.question.shiftUpLabel(label);
  }

  public shiftDownLabel(label:QuestionSetLabel) {
    this.question.shiftDownLabel(label);
  }

  public deleteLabel(label:QuestionSetLabel) {
    this.question.removeLabel(label);
  }

  private updateLabels() {
    if (!this.question) {
      this.labels = [];
    }
    this.labels = this.question.CustomLabels;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/question-labels-edit/question-labels-edit.component.ts